class Auth {
  constructor() {
    this.authenticated = false;
    this.userdata = {};
  }
  login(cb,data) {
    this.authenticated = cb;
    this.userdata = data;
    if(cb){
      
    }
  }
  logout(cb) {
    this.authenticated = false;
    this.userdata = {};
    // Keep the user's chosen Excel log columns across logout.
    // Mirrors LOG_COLUMN_PREF_PREFIX in core/dataParser.js -- kept as a literal
    // rather than an import so auth.js stays dependency-free on the login path.
    const PREFIX = "logcols_of_";
    const preserved = [];
    // Snapshot BEFORE clearing: index-iterating a store while it mutates skips entries.
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.indexOf(PREFIX) === 0) {
        preserved.push([key, localStorage.getItem(key)]);
      }
    }
    localStorage.clear();
    preserved.forEach(([k, v]) => localStorage.setItem(k, v));
    cb();
  }
  isAuthenticated() {
    return this.authenticated;
  }
  getUserData(){
    return this.userdata;
  }
}

export default new Auth();
